import { useLazyGetQuery, usePostMutation, usePutMutation } from "slices/api";
import { MOCK_DRILL_DETAILS, MOCK_DRILL_DETAILS_BY_ID } from "tagTypes";

export const useGetLazyGetMockDrillDetailsById = () => {
  const [mockDrillDetail, data] = useLazyGetQuery();
  const getMockDrillDetail = async (id) => {
    return await mockDrillDetail(
      {
        endpoint: `/mock-drill-schedule/${id}`,
        tags: [MOCK_DRILL_DETAILS_BY_ID],
      },
      true
    ).unwrap();
  };
  return [getMockDrillDetail, data];
};

export const usePostMockDrillscheduleMutation = () => {
  const [scheduleMockDrill, data] = usePostMutation();
  const MockDrill = async (payload, query = {}) => {
    return await scheduleMockDrill({
      endpoint: "/mock-drill-schedule",
      query,
      payload: payload || {},
      tags: [MOCK_DRILL_DETAILS, MOCK_DRILL_DETAILS_BY_ID],
    }).unwrap();
  };
  return [MockDrill, data];
};

export const usePostMockDrillDetailMutation = () => {
  const [mockDrillDetail, data] = usePostMutation();
  const drillDetail = async (payload, query = {}) => {
    return await mockDrillDetail({
      endpoint: "/mock-drill-detail",
      query,
      payload: payload || {},
      tags: [MOCK_DRILL_DETAILS, MOCK_DRILL_DETAILS_BY_ID],
    }).unwrap();
  };
  return [drillDetail, data];
};

export const usePutSubmitMockDrillReportMutation = () => {
  const [submitMockDrillReport, data] = usePutMutation();
  const SubmitedMockDrillReport = async (payload, query = {}) =>
    await submitMockDrillReport({
      endpoint: "/mock-drill-detail/send-developer-intimation-report",
      query,
      payload: payload || {},
      toastMessage: "Mock drill report sent successfully",
      tags: [MOCK_DRILL_DETAILS],
    }).unwrap();
  return [SubmitedMockDrillReport, data];
};
